import styled from 'styled-components';

import { Box } from '@frontend/components';
import { useSanitizedUrlOrUrlPath } from '@frontend/utils';

import { normalizeUrl } from 'utils/urlUtils';

const Mention = styled.span`
  background-color: #0077f6;
  border-radius: 10px;
  color: #fff;
  font-weight: 400;
  padding: 3px 6px;
  font-size: 12px;
  display: inline-block;
`;

const ContentMessage = styled.span`
  word-break: break-word;

  :not(:last-child) {
    padding-bottom: 8px;
  }
`;

const ContentLink = ({ content }) => {
  const { sanitizedUrlOrUrlPath } = useSanitizedUrlOrUrlPath({
    urlOrUrlPath: normalizeUrl(content),
  });

  return (
    <a href={sanitizedUrlOrUrlPath} target="_blank" rel="noopener noreferrer">
      {content}
    </a>
  );
};

// using index for key because right now these are read only so we shouldn't have to worry about react re-rednering them
const MentionsDisplay = ({ content, ...props }) => (
  <Box
    as="p"
    mb={0}
    whiteSpace="pre-wrap"
    sx={{
      a: {
        wordBreak: 'break-word',
        color: 'rgb(0, 128, 247)',
        textDecoration: 'none',
        _hover: { textDecoration: 'underline' },
      },
    }}
    {...props}
  >
    {content.map(({ content, type }, i) =>
      type === 'mention' ? (
        <Mention key={i}>@{content}</Mention>
      ) : type === 'link' ? (
        <ContentLink key={i} content={content} />
      ) : (
        <ContentMessage key={i}>{content}</ContentMessage>
      ),
    )}
  </Box>
);

export default MentionsDisplay;
